// import { Helmet } from "react-helmet";
import { Helmet } from "react-helmet-async";
import Host from "./Host";

export default function HelmetComponent({ title, metaTitle }) {
  return (
    <Helmet>
      <title>{`${title ? title : ""} ${title && "|"} ${metaTitle}`}</title>
    </Helmet>
  );
}
